export const PAGE_TYPES = {
  HOME: 'NetC.ThunderboltHome',
  HOW_IT_WORKS: 'NetC.ThunderboltHowItWorks',
  FIND_AN_EVENT: 'NetC.ThunderboltFindAnEvent',
  PRIZES: 'NetC.ThunderboltPrizes',
  GALLERY: 'NetC.ThunderboltGallery',
  M12_STUBBY_WRENCH: 'NetC.ThunderboltStubbyWrench',
};
